"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//@ts-nocheck
/**
 * Re-markup blockquotes
 *
 * @namespace
 * @memberOf txGs1Base
 * @public
 */
const _main_1 = require("./_main");
_main_1.txGs1Base.blockquotes = {
    initialize: function () {
        'use strict';
        $('.typography-blockquote').each(function (index, anchor) {
            $(this).prepend('<span class="blockquote-circle">“</span>');
            var $cite = $('.cite', this);
            $cite.replaceWith('<cite>' + $cite.text() + '</cite>');
        });
    }
};
exports.default = {};
